import { CloseCircleFilled, PlayCircleFilled } from '@ant-design/icons';

const ThumbnailVideo = ({ onClick, onClickRemove, src }) => {
  return (
    <div className="w-full h-full aspect-square rounded-md shadow-md shadow-black/25 overflow-hidden relative">
      <video className="w-full h-full object-cover" src={src} />
      <div className="cursor-pointer absolute top-1 right-1 rounded-full bg-black flex justify-center items-center" onClick={onClickRemove}>
        <CloseCircleFilled className="text-white text-lg" />
      </div>
      <div className="cursor-pointer absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white text-3xl" onClick={onClick}>
        <PlayCircleFilled />
      </div>
    </div>
  );
};

const ThumbnailImage = ({ onClick, onClickRemove, src }) => {
  const onRemove = (e) => {
    e.stopPropagation();
    onClickRemove();
  };

  return (
    <div className="w-full h-full aspect-square rounded-md shadow-md shadow-black/25 overflow-hidden relative cursor-pointer" onClick={onClick}>
      <img className="w-full h-full object-cover" src={src} alt="" />
      <div className="absolute top-1 right-1 rounded-full bg-black flex justify-center items-center cursor-pointer" onClick={onRemove}>
        <CloseCircleFilled className="text-white text-lg" />
      </div>
    </div>
  );
};

export { ThumbnailVideo, ThumbnailImage };
